import React, { useEffect, useState, useRef, useCallback } from "react";
import nodata from "../../assets/img/no-data.svg";
import { TotalroiBonusHistory } from "../../api/apiService";
import { useToken } from "../../components/TokenContext";
import Loader from "../../components/Loader";

const ROIBonus = () => {


  
 // State for mobile filter visibility
  const [showFilter, setShowFilter] = useState(false);

  // Functions to toggle/close filter
  const toggleFilter = () => setShowFilter(!showFilter);
  const closeFilter = () => setShowFilter(false);




  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState("");
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [copiedWallet, setCopiedWallet] = useState(null);

  const { token, fetchToken } = useToken();

  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  const rowsPerPage = process.env.REACT_ROW_PER_PAGE || 100;
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const formatBalance = (balance) => balance ? parseFloat(balance).toLocaleString(): "0.00";

  // Format DateTime
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      // hour: "2-digit",
      // minute: "2-digit",
      // second: "2-digit",
      // hour12: true,
    });
  };

  const copyWallet = (wallet) => {
    navigator.clipboard.writeText(wallet);
    setCopiedWallet(wallet);
    setTimeout(() => setCopiedWallet(null), 2000);
  };

  // Fetch Wallet Statement
  const fetchROIBonus = useCallback(
    async (page) => {
      setLoading(true);
      try {
        // Make Sure We Have Token
        let currentToken = token || (await fetchToken());
        if (!currentToken) return;
        const loginToken = localStorage.getItem("LoginToken") || currentToken;
        const response = await TotalroiBonusHistory(
          currentToken,
          loginToken,
          page,
          rowsPerPage,
          "",
          "",
          fromDate,
          toDate
        );
        if (response.status) {
          const dataList = response.DataList || [];
          setTableData(dataList);
          setTotalRecords(response.TotalRecords || dataList.length);
        } else {
          setTableData([]);
          setTotalRecords(0);
        }
      } 
      catch (error) {
        setTableData([]);
        setTotalRecords(0);
      } 
      finally {
        setLoading(false);
      }
    },
    [fromDate, toDate, token, fetchToken]
  );


  // Initial Load & Whenever Page Changes
  useEffect(() => {
    fetchROIBonus(currentPage);
  }, [fetchROIBonus, currentPage]);

  // Handle Search
  const handleSearch = () => {
    const page = 1;
    setCurrentPage(page);
    fetchROIBonus(page); // Pass Values Directly
  };

  // Handle Reset
  const handleReset = () => {
    setFromDate("");
    setToDate("");
    const page = 1;
    setCurrentPage(page);
    fetchROIBonus(page); // Reset Search
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
 
        <div className="buyshheikh-page">
          <div className="pageTitle">Total ROI Bonus        {/* Mobile Filter Button */}
       </div>
          <div className="card mb-3">
            <div className="card-body">

        

          

              {/* Table */}
              <div className="table-responsive">
                <table className="table table-striped table-bordered mytable">
                  <thead className="table-dark">
                    <tr>
                      <th>S.No.</th>
                       <th>Date</th>                                                 
                      <th>Invested Amount</th>
                      <th>Income Per(%)</th>                      
                      <th>Total ROI</th>
                      <th>ROI Returned</th>
                      <th>ROI Remaining</th>
                      <th>Remaining Capping</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="5" className="text-center"> 

                          <Loader />
                        </td>
                      </tr>
                    ) : tableData.length ? (
                      tableData.map((row) => (
                        <tr key={row.RowNumber}>
                           <td>{row.ROWNUMBER}</td>
                           <td>{formatDateTime(row.DATE)}</td>
                             {/* <td>{row.TITLE}</td> */}
                           <td>
                             <span
                              style={{
                                display: "inline-block",
                                padding: "4px 10px",
                                borderRadius: "5px",
                                color: "white",
                                backgroundColor: "rgb(56 81 69)",
                                minWidth: "60px",
                                textAlign: "center",
                              }}
                            >
                              ${formatBalance(row.AmountinUSD)}
                            </span>
                          </td>
                              {/* <td>
                             <span
                              style={{
                                display: "inline-block",
                                padding: "4px 10px",
                                borderRadius: "5px",
                                color: "white",
                                backgroundColor: "rgb(56 81 69)",
                                minWidth: "60px",
                                textAlign: "center",
                              }}
                            >
                              {formatBalance(row.NOOFTOKEN)}
                            </span>
                          </td> */}
                          <td>{row.MONTHLY}</td>
                          {/* <td>{row.TOTALMONTHS}</td>
                          <td>{row.PAIDMONTHS}</td>
                          <td>{row.REMANINGMONTHS}</td> */}
                          <td>${formatBalance(row.TOKENTOBECREDIT)}</td>
                          <td>${formatBalance(row.TOKENCREDITED)}</td>
                          <td>${formatBalance(row.TOKENREMANING)}</td>
                          <td>${formatBalance(row.REMAININGCAPPING)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          {/* <img src={nodata} className="not-data" alt="No Data" /> */}
                          <div>No records found</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {tableData.length > 0 && (
                <div className="d-flex justify-content-between align-items-center mt-2">
                  <div>
                    Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
                    {currentPage * rowsPerPage > totalRecords ? totalRecords : currentPage * rowsPerPage} of {totalRecords} entries
                  </div>
                  <div>
                    <ul className="pagination mb-0">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => paginate(currentPage - 1)}>Previous</button>
                      </li>
                      {[...Array(totalPages)].map((_, idx) => (
                        <li key={idx} className={`page-item ${currentPage === idx + 1 ? "active" : ""}`}>
                          <button className="page-link" onClick={() => paginate(idx + 1)}>{idx + 1}</button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => paginate(currentPage + 1)}>Next</button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
 
  );
};

export default ROIBonus;


